import { createSelector } from 'reselect';

import type { AsyncActionStatus } from '../actions/common.actionTypes';
import type { ContentItem } from '../types/AppContent';
import type { StoreType } from './index';
import { getMindItems } from './mindItems.selectors';
import { getProducts } from './products.selectors';
import type { RecentlyViewedContentArray } from './recentlyViewed.reducers';
import { getContent } from './selectorHelpers';

const getRecentlyViewedContents = (state: StoreType): RecentlyViewedContentArray =>
	state.recentlyViewed.contents;

export const selectRecentlyViewedStatus = (state: StoreType): AsyncActionStatus =>
	state.recentlyViewed.status;

export const selectRecentlyViewedContents = createSelector(
	[getRecentlyViewedContents, getMindItems, getProducts],
	(recentlyViewed, mindItems, products) =>
		recentlyViewed
			.map((i) => getContent(i.type, i.id, mindItems, products))
			.filter((v) => !!v) as ContentItem[]
);
